<template>
    <div>
        <div class="logo">
            <!-- <img src="@/assets/images/logo.svg" alt=""> -->
        </div>
        <el-menu
            background-color="#132943"
            text-color="#8994A0"
            :unique-opened="true"
            active-text-color="#fff"
            :collapse-transition="false"
            mode="vertical"
        >
            <div class="menu-wrapper" :key="index" v-for="(nav, index) in menus">
                <el-submenu :index="nav.title" v-if="nav.children.length">
                    <template slot="title">
                        <img :src="nav.icon" alt="">
                        <span>{{nav.title}}</span>
                    </template>
                    <el-menu-item-group :key="i" v-for="(item, i) in nav.children">
                        <router-link :to="item.path">
                            <el-menu-item :index="item.path">{{item.title}}</el-menu-item>
                        </router-link>
                    </el-menu-item-group>
                </el-submenu>
                <router-link v-else :to="nav.path">
                    <el-menu-item :index="nav.path">
                        <img :src="nav.icon" alt="">
                        <span slot="title">{{nav.title}}</span>
                    </el-menu-item>
                </router-link>
            </div>
      </el-menu>
      <span class="version">{{version}}</span>
    </div>
</template>

<script>
import icons from './icon.js';
export default {
    data() {
        return {
            version: window.version,
            menus: [
                {
                    title: '待办事项',
                    icon: icons.svg1,
                    path: '/todo',
                    children: []
                },
                {
                    title: '服务人员',
                    icon: icons.svg7,
                    path: '/user',
                    children: []
                },
                {
                    title: '缴费单',
                    icon: icons.svg2,
                    path: '/pay-order',
                    children: []
                },
                {
                    title: '缴费汇总',
                    icon: icons.svg3,
                    path: '/pay-summary',
                    children: []
                },
                // {
                //     title: '消费记录',
                //     icon: icons.svg4,
                //     path: '/record',
                //     children: []
                // },
                // {
                //     title: '人工扣费',
                //     icon: icons.svg5,
                //     path: '/charging',
                //     children: []
                // },
                {
                    title: '食堂价格',
                    icon: icons.svg6,
                    path: '/price',
                    children: []
                },
                {
                    title: '食堂二维码',
                    icon: icons.svg8,
                    path: '/qrcode',
                    children: []
                },
                {
                    title: '消费券',
                    icon: icons.svg10,
                    path: '/consumer-coupon',
                    children: []
                },
                {
                    title: '操作教程',
                    icon: icons.svg9,
                    path: '/course',
                    children: []
                }
            ]
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/index.vue